import { render, staticRenderFns } from "./Lacoste.vue?vue&type=template&id=a96d2318&scoped=true&"
import script from "./Lacoste.vue?vue&type=script&lang=js&"
export * from "./Lacoste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96d2318",
  null
  
)

export default component.exports